import React, { ChangeEvent } from "react";
import styles from "./input-2025.module.scss";

interface InputPropTypes {
  id?: string;
  labelText: string;
  inputPlaceHolder: string;
  inputValue: string | number;
  onChangeFunc: (e: ChangeEvent<HTMLInputElement>) => void;
  labelVariant?: string | string[];
  inputVariant?: string | string[];
  maxLength?: number;
  type?: string;
}

export const Input2025 = ({
  id,
  labelText,
  inputPlaceHolder,
  inputValue,
  onChangeFunc,
  labelVariant,
  inputVariant,
  maxLength,
  type = "text",
}: InputPropTypes) => {
  const mapVariant = (variant, prefix) =>
    Array.isArray(variant)
      ? variant.map((v) => styles[`${prefix}--${v}`]).join(" ")
      : typeof variant === "string"
      ? styles[`${prefix}--${variant}`]
      : "";

  const variantClassLabel = mapVariant(labelVariant, "input-2025__label");
  const variantClassInput = mapVariant(inputVariant, "input-2025__input");

  return (
    <label
      className={`
      ${styles["input-2025__label"]}
      ${variantClassLabel}  
      `}
    >
      {labelText}
      <input
        id={id}
        type={type}
        placeholder={inputPlaceHolder}
        value={inputValue}
        onChange={onChangeFunc}
        maxLength={maxLength}
        className={`
        ${styles["input-2025__input"]}
        ${variantClassInput}
        `}
      />
    </label>
  );
};
